import { hash } from "ohash";
import qs from "qs";

function handleError(_method, _response) {
  console.error(`[useHttp] [error] ${_method}:`, _response);
}

function checkRef(obj) {
  return Object.keys(obj).some((key) => isRef(obj[key]));
}

async function fetch(url, opts) {
  // Check the `key` option
  const { key, params, watch, body = {} } = opts;
  if (
    !key &&
    ((body && checkRef(body)) ||
      (params && checkRef(params)) ||
      (watch && checkRef(watch)))
  )
    console.error(
      "\x1B[31m%s\x1B[0m %s",
      "[useHttp] [error]",
      "The `key` option is required when `params` or `watch` has ref properties, please set a unique key for the current request.",
    );

  const options = { ...opts };
  // options.lazy = options?.lazy ?? true;

  const apiHost = ENV.currentConfig.apiHost;
  options.baseURL = apiHost;
  options.headers = {};
  if (!options.formData) {
    options.headers["Content-Type"] = "application/x-www-form-urlencoded";
  }
  options.headers = {
    ...options.headers,
  };

  if (options.client) {
    const data = ref(null);
    const error = ref(null);

    if (!options.formData) {
      options.body = qs.stringify({
        ...commonParams(),
        ...options.body,
      });
    }

    return await $fetch(url, options)
      .then((res) => {
        data.value = res.data;
        return res;
      }).catch((err) => {
        console.log(`API-ERROR[${url}]: ${err.toString()}`);
        const msg = err?.data?.data;
        error.value = msg;
        return {
          data,
          error,
        };
      });
  } else {
    const beginTimestamp = +new Date();
    setCommonParams(options);
    options.body = qs.stringify(options.body);
    console.log(`API-REQUEST-PARAMS[${url}]: ${options.body}`);
    const res = await useFetch(url, { ...options });

    // 客户端错误处理
    if (res.error.value) {
      console.log(`API-ERROR[${url}]: ${res.error.value.toString()}`);
    }else {
      const duration = (+new Date()) - beginTimestamp;
      console.log(`API-DURATION[${url}]: ${duration}ms`);
    }
    return {
      ...res.data.value,
      deviceType: options.body.deviceType,
    };
  }
}

function setCommonParams(options) {
  let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let timezoneOfset = Math.abs(new Date().getTimezoneOffset() * 60);
  let timezoneStr = `${timezone} ${timezoneOfset}`;
  const version = ENV.currentConfig.version;
  const packageName = ENV.currentConfig.packageName;
  const token = useCookie("token");
  const udid = useCookie("udid");
  if (navigator) {
    options.body.deviceType = navigator.userAgent
  } else {
    const headers = useRequestHeaders();
    const deviceType = headers["user-agent"];
    options.body.deviceType = deviceType;
  }
  let locale = ENV.currentConfig.lang;
  options.body.language = locale;
  options.body.platform = "web";
  token.value && (options.body.token = token.value);
  udid.value && (options.body.udid = udid.value);
  options.body.version = version;
  options.body.packageName = packageName;
  options.body.timezone = timezoneStr;
  options.body.timestamp = parseInt(new Date().valueOf() / 1000);
}

export const useHttp = {
  get: (url, params, option) => {
    return fetch(url, { method: "get", params, ...option });
  },

  post: (url, body, option) => {
    return fetch(url, { method: "post", body, ...option });
  },

  put: (url, body, option) => {
    return fetch(url, { method: "put", body: qs.stringify(body), ...option });
  },

  delete: (url, body, option) => {
    return fetch(url, {
      method: "delete",
      body: qs.stringify(body),
      ...option,
    });
  },
};
